/**
 * Create tennis results in popup
 */

import {
  createElement,
  getItemLocalStorage,
  setItemLocalStorage,
  select,
  selectAll,
  sortObjectByKeys,
} from "@utils/function";

export default function ResultsTennis() {
  const resultsContentSlider = select(".results-content .slider-content");

  resultsContentSlider.textContent = "";

  const tennisResults = HQ.Properties.results;

  if (tennisResults.length <= 0) return;

  // check if tennisResults element is empty or undefined
  const head = Object.entries(tennisResults)
    .map(([key, value]) => {
      if (value.length <= 0) return;
      return key;
    })
    .filter((key) => key !== undefined);

  // --------------------------------------------
  // create select match
  resultsContentSlider.insertAdjacentElement(
    "beforeend",
    createSelectMatch(tennisResults, head)
  );

  // --------------------------------------------
  // create results for each match

  Object.entries(tennisResults).forEach(([key, value], index) => {
    if (value.length <= 0) return;

    if (head.includes(key)) {
      const body = createBodyResults(value, key, head, index);
      resultsContentSlider.insertAdjacentElement("beforeend", body);
    }
  });

  // --------------------------------------------
  // show selected results

  showSelectedResults();
}

/**
 * Show selected results
 */
function showSelectedResults() {
  const selectResults = select(".tennis-select-results");
  selectResults.addEventListener("change", (e) => {
    const value = e.target.value;

    setItemLocalStorage("HQtennisResults", value);

    const results = select(`#${value}`);
    const allResults = selectAll(".tennis-row");

    allResults.forEach((result) => {
      result.classList.add("d-none");
    });

    results.classList.remove("d-none");
  });
}

/**
 * Create select match
 *
 * @param {obj} obj
 * @param {string} head
 */
function createSelectMatch(obj, head) {
  const selectMatch = createElement("div");
  selectMatch.classList.add("tennis-select-match");

  // get selected option from local storage
  const HQtennisResults = getItemLocalStorage("HQtennisResults");

  const createSelect = createElement("select");
  createSelect.classList.add("tennis-select-results");

  const objectSort = sortObjectByKeysTennis(obj);

  Object.entries(objectSort).forEach(([key, value]) => {
    if (head.includes(key)) {
      const option = createElement("option");
      option.value = key.toLowerCase();
      option.textContent = createHeaderResults(key);

      // set selected option
      option.selected = HQtennisResults === key.toLowerCase() ? true : false;
      createSelect.insertAdjacentElement("beforeend", option);
    }
  });

  selectMatch.insertAdjacentElement("beforeend", createSelect);

  return selectMatch;
}

/**
 * Create body for results
 *
 * @param {array} array
 * @param {string} key
 * @param {number} index
 * @returns  HTMLElement
 */

function createBodyResults(array, key, head, index) {
  const headRow = createElement("div");
  headRow.classList.add("tennis-row");
  headRow.id = key.toLowerCase();

  // get selected option from local storage
  const HQtennisResults = getItemLocalStorage("HQtennisResults");

  const tennisSelectResultsCountOptions = selectAll(
    ".tennis-select-results option"
  ).length;

  if (HQtennisResults === key.toLowerCase()) {
    headRow.classList.remove("d-none");
  } else {
    // if select has more than one option hide headRow
    if (tennisSelectResultsCountOptions > 1) {
      headRow.classList.add("d-none");
    }
    if (!HQtennisResults) {
      const firsrtElement = head[0].toLowerCase();
      const findElementById = select(`#${firsrtElement}`);
      findElementById?.classList.remove("d-none");
    }
  }

  array.map((item, index) => {
    if (array[index - 1]?.RoundLongName !== item.RoundLongName) {
      headRow.innerHTML += `<div class="tennis-second-row px-2 py-1">${item.RoundLongName}</div>`;
    }

    headRow.innerHTML += getPlayersName(item);
  });

  return headRow;
}

/**
 * Create header for results
 *
 * @param {string} element
 * @returns HTMLElement
 */
function createHeaderResults(element) {
  let eventtypeName;

  switch (element) {
    // -------------------------
    // ATP
    case "MS":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.MS;
      break;
    case "MD":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.MD;
      break;
    case "QS":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.QS;
      break;
    case "QD":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.QD;
      break;
    // -------------------------
    // WTA
    case "LS":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.LS;
      break;
    case "LD":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.LD;
      break;
    case "RS":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.RS;
      break;
    case "RD":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.RD;
      break;

    default:
      break;
  }

  return eventtypeName;
}
/**
 * Get players name
 *
 * @param {object} players
 * @returns string
 */
function getPlayersName(players) {
  // const orderedObject = sortObjectByKeys(players);
  // console.log(orderedObject);

  // const dataObj = Object.entries(players).map((k) => ({ [k[0]]: k[1] }));
  // console.log(dataObj);

  const {
    PlayerFirstName,
    PlayerLastName,
    PlayerNatlId,
    PlayerId,
    PartnerFirstName,
    PartnerNatlId,
    PartnerLastName,
    PartnerId,
    OpponentFirstName,
    OpponentLastName,
    OpponentNatlId,
    OpponentId,
    OpponentPartnerFirstName,
    OpponentPartnerLastName,
    OpponentPartnerNatlId,
    OpponentPartnerId,
    WinningPlayerId,
  } = players;

  const checkmarkPlayer = WinningPlayerId === PlayerId ? "&#x2713;" : "";
  const checkmarkPartner = WinningPlayerId === PartnerId ? "&#x2713;" : "";
  const checkmarkOponent = WinningPlayerId === OpponentId ? "&#x2713;" : "";
  const checkmarkOponentPartner =
    WinningPlayerId === OpponentPartnerId ? "&#x2713;" : "";

  const countPlayers = OpponentPartnerId ? true : false;

  // -------------------------
  let playerRow = "";

  if (PlayerFirstName) {
    const config = {
      firstName: PlayerFirstName,
      lastName: PlayerLastName,
      natlId: PlayerNatlId,
    };
    playerRow = rowPlayer(
      PlayerId,
      config,
      "left",
      checkmarkPlayer,
      countPlayers,
      WinningPlayerId
    );
  }

  // -------------------------
  let partnerRow = "";

  if (PartnerFirstName) {
    const config = {
      firstName: PartnerFirstName,
      lastName: PartnerLastName,
      natlId: PartnerNatlId,
    };
    partnerRow = rowPlayer(
      PartnerId,
      config,
      "left",
      checkmarkPartner,
      countPlayers,
      WinningPlayerId
    );
  }

  // -------------------------
  let opponentRow = "";

  if (OpponentFirstName) {
    const config = {
      firstName: OpponentFirstName,
      lastName: OpponentLastName,
      natlId: OpponentNatlId,
    };
    opponentRow = rowPlayer(
      OpponentId,
      config,
      "right",
      checkmarkOponent,
      countPlayers,
      WinningPlayerId
    );
  }

  // -------------------------
  let opponentPartnerRow = "";

  if (OpponentPartnerFirstName) {
    const config = {
      firstName: OpponentPartnerFirstName,
      lastName: OpponentPartnerLastName,
      natlId: OpponentPartnerNatlId,
    };
    opponentPartnerRow = rowPlayer(
      OpponentPartnerId,
      config,
      "right",
      checkmarkOponentPartner,
      countPlayers,
      WinningPlayerId
    );
  }

  let playersID = "";
  playersID += PlayerId ? PlayerId : "";
  playersID += PartnerId ? `,${PartnerId}` : "";
  playersID += OpponentId ? `,${OpponentId}` : "";
  playersID += OpponentPartnerId ? `,${OpponentPartnerId}` : "";

  const hasFavoritePlayer = checkFavoritePlayer(playersID)
    ? "favorite-player"
    : "";
  // Z355, SU87;

  let checkHowManyPlayers = partnerRow ? " mb-2" : "";

  const playerRowDiv = `
    <div class="container flex-column border-bottom">
      <div data-id=${playersID} class="d-flex row py-1 ${hasFavoritePlayer}">
        <div class="col-9">
          <div class="players-results${checkHowManyPlayers}">
            ${playerRow}${partnerRow ?? ""}
          </div>
          <div class="players-results">
            ${opponentRow}${opponentPartnerRow ?? ""}
          </div>
        </div>
        <div class="d-flex col-3 flex-column justify-content-around">
          ${getScoreColumnNew(players)}
        </div>
      </div>
    </div>
  `;

  return playerRowDiv;
}

/**
 * Create player row
 *
 * @param {object} obj
 * @param {string} type
 * @returns string
 */
function rowPlayer(
  playerId,
  obj,
  type,
  checkmark,
  countPlayers = false,
  winningPlayerId
) {
  let { firstName, lastName, natlId } = obj;

  firstName = firstName ? firstName.slice(0, 1) + ". " : "";

  checkmark =
    checkmark && !countPlayers
      ? `<span class="tennis-winning ms-2 text-center">${checkmark}</span>`
      : "";

  const tennisWinningFloat =
    countPlayers && winningPlayerId === playerId ? "tennis-winning-float" : "";

  return `
    <div class="player-row tennis-flag d-flex gap-2 align-items-center ${tennisWinningFloat}">
      <div title="${natlId}" class="col-2 flag-icon flag-icon-${natlId?.toLowerCase()}"></div>
      <div class="col-10">${firstName}${lastName}${checkmark}</div>
    </div>
  `;
}

/**
 * Get score for results
 * @param {object} obj
 */
function getScoreColumnNew(data) {
  // console.log("id, resultString", courtID, ResultString);
  // if (courtID == 3 || courtID == 1 || courtID == 2) return;

  if (!data) return;

  const createResults = (data) => {
    const rowPlayerA = [];
    const rowPlayerB = [];

    // get Set1Player when number is changing in string regx
    const regxPlayer = /Set\dPlayer/g;
    const regxOpponent = /Set\dOpponent/g;
    const regxTie = /Set\dTie/g;
    // const regxReson = /Reason/g;

    // add index to for in loop
    let i = 0;
    for (const key in data) {
      // console.log(regx.test(key));

      // if data data[key] has A then push to rowPlayerA
      if (regxPlayer.test(key) && !regxTie.test(key) && data[key] != null) {
        rowPlayerA.push(data[key]);
      }

      // if data data[key] has B then push to rowPlayerB not TB
      if (regxOpponent.test(key) && !regxTie.test(key) && data[key] != null) {
        rowPlayerB.push(data[key]);
      }

      // if kayy incliude ScoreTB string
      if (regxTie.test(key) && data[key] != null) {
        const curentScore = Object.keys(data)[i];
        const previusElement = Object.keys(data)[i - 1];

        if (regxPlayer.test(previusElement)) {
          const lastElement = rowPlayerA.pop();
          rowPlayerA.push(`${lastElement}<sup>${data[curentScore]}</sup>`);
        }

        if (regxOpponent.test(previusElement)) {
          const lastElement = rowPlayerB.pop();
          rowPlayerB.push(`${lastElement}<sup>${data[curentScore]}</sup>`);
        }
      }
      i += 1;
    }

    const reason = data.Reason;
    if (reason) {
      rowPlayerB.push(reason);
    }

    return { rowPlayerA, rowPlayerB };
  };

  const results = createResults(data);

  // results for player A generate div with class tennis-results-top
  const resultsA = results.rowPlayerA
    .map((score, index) => {
      return `<div class="col-3">${score}</div>`;
    })
    .join("");

  const resultsB = results.rowPlayerB
    .map((score, index) => {
      // if score is string and not html tag
      if (typeof score === "string" && !score.includes("<")) {
        return `<div class="col-3 score-text-small">${score}</div>`;
      } else {
        return `<div class="col-3">${score}</div>`;
      }
    })
    .join("");

  // console.log(resultsA, resultsB);

  return `
    <div class="row">${resultsA}</div>
    <div class="row">${resultsB}</div>`;
}

/**
 * Check if favorite player in local storage
 */
function checkFavoritePlayer(playersID) {
  const arrayPlayersID = playersID.split(",");

  const getFavoritePlayer = getItemLocalStorage("HQfavoritePlayers");

  // elements from arrayPlayersID find in getFavoritePlayer
  const favoritePlayer = arrayPlayersID.filter((item) =>
    getFavoritePlayer?.includes(item)
  );

  return favoritePlayer.length > 0 ? true : false;
}

/**
 * Sort object by keys depending on the orderTennis array
 *
 * @param {object} obj
 * @returns object
 */
function sortObjectByKeysTennis(obj) {
  const orderTennis = ["MS", "MD", "QS", "QD", "LS", "LD", "RS", "RD"];

  // sort object depending on the index of the orderedObject array
  const sorted = Object.keys(obj)
    .sort((a, b) => orderTennis.indexOf(a) - orderTennis.indexOf(b))
    .reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});

  return sorted;
}
